import React from "react";
import { Container} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Button from "react-bootstrap/Button";


function SoundofIndia() {
  return (
    <>
      <Container>
      <div class="row">
      <div class="col-12">
        <div class="contentbox">
        {/* Content Section */}
        <h1 className="cus_text60">INDIA IN EVERY BEAT</h1>
        <p className="cus_text30">
          Each pasture and every lane in India sings myriad unique melodies of life happening. Whether it’s the trilling score of a cycle rickshaw rushing little children to school or the sound of erecting a house of someone’s dreams, you won’t miss the sounds of steel in action. To capture these eclectic sounds and tune them into a unique soundscape, maverick sound artist Sneha Khanwalkar travelled far and wide across India. What she created went on to become the sonic identity of the Steel of India campaign.
        </p>
        
        <a href="https://open.spotify.com/track/0Kw2cEGoSSgTG9tpuYgdMG?si=P8nG_20UTQ2ZingaIhbvVQ">
          <Button
            variant=" d-flex align-items-center"
            style={{
              borderRadius: "100px",
              padding: "10px 20px",
              border: "2px solid #ccc",
            }}
          >
            <b>Sound of India | </b>
            <img
              src="https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826188sofy.png"
              alt="Icon"
              style={{
                width: "100px",
                height: "auto",
                marginRight: "8px",
              }}
            />
          </Button>
        </a>
        </div>
        </div>
        </div>
      </Container>
    </>
  );
}

export default SoundofIndia;
